module.exports = __webpack_public_path__ + "static/coffee-4e0f3837281acba59ecd0a627ada1767.jpg";